import { render } from "./OptStatView.vue?vue&type=template&id=8fcb6780"
import script from "./OptStatView.vue?vue&type=script&lang=js"
export * from "./OptStatView.vue?vue&type=script&lang=js"

import "./OptStatView.vue?vue&type=style&index=0&id=8fcb6780&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__